
export const PHONE = '576px';
export const TABLET = '768px';
export const DESKTOP = '992px';
export const WIDE_DESKTOP = '1200px';
export const MEDIUM_DESKTOP = '1600px';
